﻿import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { User } from '../../_models';
import { AuthenticationService } from '../../_services';
import { Router, ActivatedRoute } from '@angular/router';

@Component({ templateUrl: 'social.component.html' })
export class SocialComponent implements OnInit, OnDestroy {
    currentUser: User;
    currentUserSubscription: Subscription;


    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
            this.currentUser = user;
        });
        this.route.queryParams.subscribe(params => {
            this.social(params['token']);
        });
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.currentUserSubscription.unsubscribe();
    }

    social(token: string) {
        this.authenticationService.getUserLogin(token)
            .subscribe(
                data => {
                    this.router.navigate(['']);
                })
    }


}
